import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ReportService } from '../../services/report/report.service';
import { first, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ReportInventoryDetailResolve implements Resolve<any> {

    constructor(private rs: ReportService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let id = +route.params['id'];
        return this.rs.getInventoryDetail(id).pipe(map(product => product)).pipe(first());
    }

}
